export const scanRequestMoveModalId = 'scanRequestMoveModal';
export const scanRequestDetachModalId = 'scanRequestDetachModal';
export const scanRequestDeleteModalId = 'scanRequestDeleteModal';
export const scanRequestRestoreModalId = 'scanRequestRestoreModal';
export const scanRequestFormModalId = 'scanRequestFormModalId';
export const scanRequestUpdateModalId = 'scanRequestUpdateModal';
export const scanRequestAlertId = 'scanRequestAlert';
export const scanRequestFilterFormId = 'scanRequestFilterForm';
export const scanRequestArchiveModalId = 'signRequestArchiveModal';
